<template>
  <ul class="menu">
    <li
        v-for="item in filteredMenu"
        :class="[item.additionalClass]"
    >
      <a :href="$getSubdomainLink(item.subdomain, item.route)"
         class="menu__item"
         :class="{
            active: $route.path.includes(item.route),
          }"
      >
        {{ item.name }}
      </a>
    </li>
  </ul>
</template>
<script>
  import { useAuthStore, useEnabledStore } from "@/stores";
  export default {
    data() {
      return {
        authStore: useAuthStore(),
        enabledStore: useEnabledStore(),
      };
    },
    computed: {
      menu () {
        return [
          {
            name: 'Videos',
            route: '/video/catalog',
            subdomain: 'portal',
            forAuth: false
          },
          {
            name: 'Books',
            route: '/books/catalog',
            subdomain: 'portal',
            forAuth: false,
            isPortalTypeBooks: true
          },
          {
            name: 'Blog',
            route: '/blog/catalog',
            subdomain: 'portal',
            forAuth: false
          },
          {
            name: 'Playlists',
            route: '/playlists',
            subdomain: 'portal',
            forAuth: true
          },
          {
            name: 'Progress',
            route: '/chart',
            subdomain: 'portal',
            forAuth: false
          },
          {
            name: 'Goals',
            route: '/preferences',
            subdomain: 'portal',
            forAuth: true
          },
          {
            name: 'Favorites',
            route: this.isPortalTypeBooks ? '/books/favorite' : '/video/favorite',
            subdomain: 'portal',
            forAuth: true,
            isPortalTypeBooks: true,
            additionalClass: 'with-divider'
          },
        ].filter(item => !item.forAuth || this.isAuth)
      },
      filteredMenu() {
        return this.menu.filter(item => {
          if (!this.isAuth && item.forAuth) return false;

          if (this.isPortalTypeBooks) {
            return item.isPortalTypeBooks === true;
          }

          return true
        });
      },
      isAuth() {
        return this.authStore.isAuth;
      },
      isPortalTypeBooks() {
        return this.enabledStore.portalTypeBooks;
      },
    },
  };
</script>

<style
  scoped
  lang="scss"
>
.menu {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 2.08vw;

  li {
    a {
      padding: 2px 4px;
      color: $main-light;
      transition: $transition;
      &:hover,
      &.active{
        color: $accent;
      }
    }

    &.with-divider {
      padding-left: 2.08vw;
      position: relative;

      &::before {
        content: '';
        width: 1px;
        height: 40px;
        background-color: $gray-light;
        display: block;
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        margin: auto;
      }
    }
  }

  @media (max-width: $breakpoint-xl) {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    gap: 16px;
    margin-bottom: 16px;

    li {
      &.with-divider {
        padding-left: 0;

        &::before {
          display: none;
        }
      }
    }
  }
}
</style>